import { render } from "./ProductGroup.vue?vue&type=template&id=945cbaea"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__